export const getPushPossibility = (state) => state.mode.pushPossibility
export const getInstallPossibility = (state) => state.mode.installPossibility
export const getPushesGranted = (state) => state.mode.pushesGranted
export const getMode = (state) => state.mode.mode
export const getAgent = (state) => state.mode.agent
